import { Link } from "react-router-dom";

export const LLink = ({ link = "", children }) => (
  <li className="px-3 py-1.5 rounded-sm hover:bg-light-gray">
    <Link to={"/" + link}>{children}</Link>
  </li>
);
export const CSRF = () => (
  <input
    type="hidden"
    name="csrfmiddlewaretoken"
    value={document.cookie.match(/csrftoken=(\w+)/)[1]}
  />
);
